import {
  Avatar,
  Hidden,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import React from "react";
import useShowImage from "../../hooks/useShowImage";
import { useStore } from "../../hooks/useStore";
import { useStyles } from "./UserInfoStyles";

const UserInfo = () => {
  const classes = useStyles();
  const { authStore } = useStore();
  //Se agrega funcion de imagen, el parametro de imagen del guardia deberia ser facePhoto
  const show = useShowImage();
  return (
    <div>
      <Hidden smDown>
        <List className={classes.noPadding}>
          <ListItem className={classes.userInfo}>
            {authStore.user?.facePhoto && (
              <ListItemAvatar>
                <Avatar alt="Guard" src={show(authStore.user.facePhoto)} />
              </ListItemAvatar>
            )}
            <ListItemText
              className={classes.dataMobile}
              primary={authStore.user?.name}
              secondary={authStore.country?.countryName}
            />
          </ListItem>
        </List>
      </Hidden>
      <Hidden mdUp>
        <List className={classes.listUserInfo}>
          <ListItem className={classes.listUserInfo}>
            {authStore.user?.facePhoto && (
              <ListItemAvatar>
                <Avatar
                  alt="Guard"
                  src={show(authStore.user.facePhoto)}
                  className={classes.large}
                />
              </ListItemAvatar>
            )}
            <ListItemText
              className={classes.dataMobile}
              primary={authStore.user?.name}
              secondary={authStore.country?.countryName}
            />
          </ListItem>
        </List>
      </Hidden>
    </div>
  );
};

export default UserInfo;
